<template>
  <div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>

      <li class="active">Push Notification</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Push Notification</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Push Notif</h4>
          </div>
          <div class="panel-body panel-form">
            <div class="row" style="padding: 20px">
              <div class="col-md-12">
                <button
                  class="btn btn-primary-outline"
                  data-toggle="collapse"
                  data-target="#demo"
                >
                  List Push Notif
                </button>
                <div id="demo" class="collapse">
                  <div class="row mt-3">
                    <div class="col-md-12">
                      <table class="table">
                        <thead>
                          <th v-for="(item, index) in headers" :key="index">
                            {{ item }}
                          </th>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in listPush" :key="index">
                            <td>{{ item.channel }}</td>
                            <td>{{ item.title }}</td>
                            <td>{{ item.scheduled_at | convertDate()}}</td>
                            <td>{{ item.created_at | convertDate()}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-md-12 text-right" style="display:flex; justify-content:flex-end; align-items:center;">
                    <button
                      class="btn btn-primary"
                      @click="paging(-1)"
                      :disabled="pagination.current_page === 1"
                    >
                      Previous
                    </button>
                    <div style="margin:15px; font-size: 18px;">
                    {{ pagination.current_page + '/' + pagination.total_page }}
                    </div>
                    <button
                      class="btn btn-primary"
                      @click="paging(1)"
                      :disabled="pagination.current_page === pagination.total_page"
                    >
                      Next
                    </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-body panel-form">
            <div
              class="alert alert-danger fade in m-b-15"
              v-if="this.errors.length > 0"
            >
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">
                  {{ message }}
                </li>
              </ul>
            </div>
            <form class="" style="margin-top: 20px; margin-left: 20px">
              <div class="form-group">
                <label class="control-label">Mode Notifikasi</label>
                <div class="row">
                  <div class="col-md-7">
                    <select class="form-control" v-model="inputMode">
                      <option value="1">Notifikasi Umum</option>
                      <option value="2">Notifikasi Dengan Konten</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label">Jadwalkan Push Notif</label>
                <div class="row">
                  <div class="col-md-7 col-xs-12">
                    <div class="row">
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group">
                          <input
                            id="scheduledDate"
                            v-model="scheduledDate"
                            type="text"
                            class="form-control datepicker"
                            placeholder="Tanggal Notif akan dipush"
                            name="scheduled_date"
                            readonly
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6 col-xs-12">
                        <div class="input-group clockpicker">
                          <input
                            id="scheduledTime"
                            v-model="scheduledTime"
                            type="text"
                            class="form-control"
                            placeholder="Jam : Menit"
                            name="scheduled_time"
                            readonly
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-clock-o"></i>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-group"
                v-bind:class="{ 'has-error': errors.indexOf('title') >= 0 }"
              >
                <label class="control-label">Judul</label>
                <div class="row">
                  <div class="col-md-7">
                    <input
                      type="text"
                      v-model="form.title"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                v-bind:class="{ 'has-error': errors.indexOf('text') >= 0 }"
              >
                <label class="control-label">Pesan</label>
                <div class="row">
                  <div class="col-md-7">
                    <textarea
                      class="form-control"
                      v-model="form.text"
                      name=""
                      id=""
                      cols="130"
                      rows="10"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                v-if="inputMode === '2'"
                v-bind:class="{ 'has-error': errors.indexOf('imageurl') >= 0 }"
              >
                <label class="control-label">Gambar</label>
                <div class="row">
                  <div class="col-md-7">
                    <input
                      type="text"
                      v-model="form.imageurl"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                v-if="inputMode === '2'"
                v-bind:class="{ 'has-error': errors.indexOf('content') >= 0 }"
              >
                <label class="control-label">Konten</label>
                <div class="row">
                  <div class="col-md-7">
                    <textarea
                      class="form-control"
                      v-model="form.content"
                      name=""
                      id=""
                      cols="130"
                      rows="10"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="form-group" v-if="inputMode === '2'">
                <label class="control-label">Link (opsional)</label>
                <div class="row">
                  <div class="col-md-7">
                    <input
                      type="text"
                      v-model="form.link"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                v-if="inputMode === '2'"
                v-bind:class="{ 'has-error': errors.indexOf('cta') >= 0 }"
              >
                <label class="control-label">Call to Action</label>
                <div class="row">
                  <div class="col-md-7">
                    <input
                      type="text"
                      v-model="form.cta"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <button
                  type="button"
                  class="btn btn-success btn-md"
                  @click="nextButton()"
                >
                  Selanjutnya
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="konfirmpushnotif"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body" v-if="modeDialogForm == '1'">
            <div class="col-md-12" style="text-align: center">
              FCM Token
              <input
                type="text"
                v-model="fcmtoken"
                class="form-control"
                style="margin-top: 10px"
              />
            </div>
            <div class="row mt-3">
              <div class="col-md-12" style="text-align: center">
                <button class="btn btn-warning" @click="submitNotification('test')">
                  Kirim Test
                </button>
                <button class="btn btn-success" @click="submitNotification('all')">
                  Kirim Semua
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body" v-if="modeDialogForm == '2'">
            <p>Data testing berhasil terkirim</p>
            <p>Harap periksa apakah notifikasi sudah berhasil diterima</p>
            <div class="row mt-3">
              <div class="col-md-12" style="text-align: center">
                <button class="btn btn-warning" @click="closeModal()">
                  Edit Pesan
                </button>
                <button class="btn btn-success" @click="submitNotification('all')">
                  Kirim Semua
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body" v-if="modeDialogForm == '3'">
            <p>Data berhasil terkirim ke seluruh user</p>

            <div class="row mt-3">
              <div class="col-md-12" style="text-align: center">
                <button class="btn btn-warning" @click="closeModal()">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import axios from "axios";

import Spinner from "@/components/plugins/Spinner";
import "vue-search-select/dist/VueSearchSelect.css";
import DataTable from "@/components/plugins/DataTable";
import NotificationService from "@/services/notification.js"
import moment from 'moment'

// import { ModelSelect } from 'vue-search-select'
export default {
  name: "content-article-form",
  components: {
    "app-spinner": Spinner,
    "app-datatable": DataTable,
  },
  data: function () {
    return {
      isLoading: false,
      inputMode: "1",
      form: {
        title: null,
        text: null,
        imageurl: null,
        content: null,
        link: null,
        cta: null,
      },
      pagination: {
        current_page: 1,
        total_page: 0,
      },
      scheduledDate: '',
      scheduledTime: '',
      fcmtoken: null,
      modeDialogForm: "1",
      databody: null,
      errors: [],
      headers: ["Channel", "Judul Notifikasi", "Tanggal Push", "Created At"],
      listPush: [],
    };
  },
  watch:{
    
  },
  filters: {
    convertDate(v) {
      return moment.unix(v / 1000).format("DD/MMMM/YYYY HH:mm:ss");
    },
  },
  mounted: function () {
    let context = this
    if (localStorage.pushnotif) {
      let bb = JSON.parse(localStorage.pushnotif);
      this.form = bb;
    }
    DatepickerPlugin.init("#scheduledDate", function (value) {
      context.scheduledDate = value;
    });

    ClockpickerPlugin.init("#scheduledTime", function (value) {
      context.scheduledTime = value;
    });
    this.getListNotif()
  },
  methods: {
    nextButton() {
      if (this.validateForm(this.inputMode)) {
        this.modeDialogForm = "1";
        $("#konfirmpushnotif").modal("show");
      }
    },
    closeModal() {
      this.modeDialogForm = "1";
      $("#konfirmpushnotif").modal("hide");
    },
    paging(pg){
      this.pagination.current_page = this.pagination.current_page + pg
      this.getListNotif()
    },
    getListNotif(){
      var context = this
      NotificationService.getNotifSchedules(this.pagination,function (result) {
        context.listPush = result.data.data
        context.pagination.total_page = result.data.total_page
      })
    },
    // preparingBody(mode) {
    //   var context = this;
    //   context.databody = {
    //     // d5ccCN0LRyK9Rkr-hn9wuF:APA91bF_I_Fbmnu9Dhu3q2aK8kNcOheYvnbfXj0foml5vBWuZrYqxa1a_qKmW37l3albSP1gwoYFB1m7ZLONinudHWtbWbSaxMb1g9RHsk-i97dzlhIrPUeZrYN6qTvld_m9URn9hccq
    //     to: mode === "test" ? context.fcmtoken : "/topics/global",
    //   };
    //   if (context.inputMode == "1") {
    //     context.databody.notification = {
    //       title: context.form.title,
    //       body: context.form.text,
    //       type: "ANNOUNCEMENT",
    //       channel: "CHANNEL_GLOBAL",
    //     };
    //   } else {
    //     let payload =
    //       '{"image_url": "' +
    //       context.form.imageurl +
    //       ' ","description": "' +
    //       context.form.content +
    //       '","button_url": "' +
    //       context.form.link +
    //       '","button_text": "' +
    //       context.form.cta +
    //       '"}';
    //     context.databody.data = {
    //       title: context.form.title,
    //       body: context.form.text,
    //       type: "ANNOUNCEMENT",
    //       channel: "CHANNEL_GLOBAL",
    //       payload: payload,
    //     };
    //   }

    //   localStorage.setItem("pushnotif", JSON.stringify(context.form));
    // },
    // sendButtonTest(m) {
    //   // console.log(m);
    //   if (this.fcmtoken === null || this.fcmtoken === "") {
    //     alert("fcm wajib diisi");
    //     return false;
    //   } else if (this.fcmtoken !== null && this.fcmtoken !== "") {
    //     var context = this;
    //     this.isLoading = true;
    //     this.preparingBody(m);
    //     var url = "https://fcm.googleapis.com/fcm/send";

    //     var http = axios.create({
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "key=" + process.env.NOTIFICATION_AUTH,
    //       },
    //     });
    //     http
    //       .post(url, context.databody)
    //       .then((response) => {
    //         if (response.data.failure === 1) {
    //           alert("data gagal dikirim: " + response.data.results[0].error);
    //         } else {
    //           context.modeDialogForm = m === "all" ? "3" : "2";
    //         }
    //         context.isLoading = false;
    //       })
    //       .catch((err) => {
    //         alert("Error Push Notif");
    //         context.isLoading = false;
    //       });
    //   }
    // },
    // sendButtonAll(m) {
    //   if (
    //     confirm("Apakah anda yakin akan mengirim notifikasi keseluruh user?") ==
    //     true
    //   ) {
    //     var context = this;
    //     this.isLoading = true;
    //     this.preparingBody(m);
    //     var url = "https://fcm.googleapis.com/fcm/send";

    //     var http = axios.create({
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "key=" + process.env.NOTIFICATION_AUTH,
    //       },
    //     });
    //     http
    //       .post(url, context.databody)
    //       .then((response) => {
    //         if (response.data.failure === 1) {
    //           alert("data gagal dikirim: " + response.data.results[0].error);
    //         } else {
    //           context.modeDialogForm = m === "all" ? "3" : "2";
    //         }
    //         context.isLoading = false;
    //       })
    //       .catch((err) => {
    //         alert("Error Push Notif");
    //         context.isLoading = false;
    //       });
    //   } else {
    //     return false;
    //   }
    // },

    submitNotification(m){
      let context = this
      context.isLoading = true
      let scheduledEpoch = moment(context.scheduledDate + ' ' + context.scheduledTime, "DD/MM/YYYY HH:mm").valueOf()
      let form = context.form
      if(context.inputMode === '1') {
        form.content = null
        form.imageurl = null
        form.cta = null
        form.link = null
      }
      let body = {
        "title": form.title,
        "body": form.text,
        "description": form.content,
        "image_url": form.imageurl,
        "button_url": form.link,
        "button_text": form.cta,
        "scheduled_at": isNaN(scheduledEpoch) ? null : scheduledEpoch,
        "fcm_token": context.fcmtoken
      }
      localStorage.setItem("pushnotif", JSON.stringify(context.form));
      NotificationService.submitNotification(body, function (response) {
        console.log(response)
        if(response.success){
          context.modeDialogForm = m === "all" ? "3" : "2";
        } else {
          alert("data gagal dikirim: " + response.message);
        }
        context.isLoading = false
      })
    },
    validateForm: function (m) {
      this.errors = [];
      if (m === "1") {
        if (this.form.title === "" || this.form.title === null)
          this.errors.push("Judul wajib diisi");
        if (this.form.text === "" || this.form.text === null)
          this.errors.push("Pesan wajib diisi");
      } else {
        if (this.form.title === "" || this.form.title === null)
          this.errors.push("Judul wajib diisi");
        if (this.form.text === "" || this.form.text === null)
          this.errors.push("Pesan wajib diisi");
        if (this.form.imageurl === "" || this.form.imageurl === null)
          this.errors.push("Gambar wajib diisi");
        if (this.form.content === "" || this.form.content === null)
          this.errors.push("Konten wajib diisi");
        if (this.form.cta === "" || this.form.cta === null)
          this.errors.push("Call to action wajib diisi");
      }
      return this.errors.length == 0;
    }
  },
};
</script>



// WEBPACK FOOTER //
// PushNotif.vue?8b0a80d2